/* ==========================================================================
   TNF CATALOGUE production record 1.2.0                         2026-09-25
   For every catalogue design: the BACKBOARD the factory makes it with (Clear,
   or UV Print where the design has printed or infilled artwork) and, for a
   design made in its own fixed colours, its NEON COLOURS. These fill the
   order line's Backboard Colour and Neon Colour (the Cindy sheet's G and D).
   Sources, in order: the manufacturing sheets (1.0.0 - what the factory has
   already been told), then the product photo (25 Sep 2026 reviews, named in
   the store's colour names). A customer-chosen colour always comes from the
   customer's choice, never from here. The evidence for each entry is kept in
   the internal catalogue report, not in this file.
   ========================================================================== */
(function (root) {
  var TNF_CAT_MFG = {
  "13-led-neon-sign": {"backboard":"Clear"},
  "16-led-neon-sign": {"backboard":"Clear"},
  "18-led-neon-sign": {"backboard":"Clear"},
  "20-off-led-neon-sign": {"backboard":"Clear"},
  "21-baby-led-neon-sign": {"backboard":"Clear"},
  "21-led-neon-sign": {"backboard":"Clear"},
  "25-off-led-neon-sign": {"backboard":"Clear"},
  "3-flowers-led-neon-sign": {"colours":["Red","Golden Yellow","Green","Lemon Yellow","Ice Blue"],"backboard":"Clear"},
  "30-led-neon-sign": {"backboard":"Clear"},
  "30-off-led-neon-sign": {"backboard":"Clear"},
  "3rd-eye-led-neon-sign": {"colours":["Ice Blue"],"backboard":"UV Print"},
  "40-baby-led-neon-sign": {"backboard":"Clear"},
  "40-led-neon-sign": {"backboard":"Clear"},
  "40-off-led-neon-sign": {"backboard":"Clear"},
  "50-led-neon-sign": {"backboard":"Clear"},
  "50-off-led-neon-sign": {"backboard":"Clear"},
  "60-led-neon-sign": {"backboard":"Clear"},
  "abstract-toilet": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "addidas": {"backboard":"Clear"},
  "air-jordan": {"colours":["Cold White","Orange"],"backboard":"Clear"},
  "ak47": {"backboard":"Clear"},
  "alien-led-neon-sign": {"colours":["Green","Cold White","Lemon Yellow"],"backboard":"Clear"},
  "all-i-want-is-a-tan-led-neon-sign": {"backboard":"Clear"},
  "all-of-me-loves-all-of-you-led-neon-sign": {"backboard":"Clear"},
  "all-of-me-loves-all-of-you-led-neon-sign-1": {"backboard":"Clear"},
  "all-you-need-is-brows-led-neon-sign": {"colours":["Pink","Cold White"],"backboard":"Clear"},
  "all-you-need-is-great-hair-led-neon-sign": {"backboard":"Clear"},
  "all-you-need-is-love-led-neon-sign": {"backboard":"Clear"},
  "always-and-forever-led-neon-sign": {"backboard":"Clear"},
  "american-football": {"backboard":"Clear"},
  "amour-led-neon-sign": {"backboard":"Clear"},
  "anaheim-hockey-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "and-so-our-adventure-begins-led-neon-sign": {"backboard":"Clear"},
  "angel-heart": {"backboard":"Clear"},
  "angel-wings": {"colours":["Orange","Lemon Yellow","Red","Ice Blue","Blue"],"backboard":"Clear"},
  "angry-mickey": {"backboard":"Clear"},
  "angry-pumpkin": {"colours":["Orange","Green"],"backboard":"Clear"},
  "apollo-13-led-neon-sign": {"colours":["Red","Cold White","Lemon Yellow","Ice Blue"],"backboard":"UV Print"},
  "apple-led-neon-sign": {"backboard":"Clear"},
  "arcade-led-neon-sign": {"colours":["Lemon Yellow","Red","Ice Blue","Green","Orange"],"backboard":"Clear"},
  "are-you-looking-at-me-led-neon-sign": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "arizona-american-football-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "arizona-baseball-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "ash-tray": {"backboard":"Clear"},
  "astronaut-led-neon-sign": {"colours":["Purple","Lemon Yellow"],"backboard":"UV Print"},
  "athletics-baseball-led-neon-sign": {"colours":["Green"],"backboard":"Clear"},
  "atlanta-american-football-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "atlanta-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "atlanta-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "austin-soccer-team-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "babe-you-look-soo-cool-led-neon-sign": {"backboard":"Clear"},
  "baby-bird-led-neon-sign": {"colours":["Lemon Yellow","Cold White"],"backboard":"Clear"},
  "baby-bunny-led-neon-sign": {"backboard":"Clear"},
  "baby-bunny-led-neon-sign-copy": {"backboard":"Clear"},
  "baby-chick-led-neon-sign": {"colours":["Lemon Yellow","Cold White"],"backboard":"Clear"},
  "baby-dino-led-neon-sign": {"colours":["Ice Blue","Pink","Cold White","Green"],"backboard":"Clear"},
  "baby-pass-me-the-hookah-led-neon-sign-1": {"backboard":"Clear"},
  "baby-rabbit-led-neon-sign": {"colours":["Orange","Ice Blue","Red"],"backboard":"Clear"},
  "baby-rabbit-led-neon-sign-1": {"backboard":"Clear"},
  "bad-decisions-make-better-stories-led-neon-sign": {"backboard":"Clear"},
  "bad-girl-led-neon-sign": {"colours":["Red","Lemon Yellow"],"backboard":"UV Print"},
  "bad-girl-led-neon-sign-1": {"colours":["Green","Red"],"backboard":"Clear"},
  "badass-with-a-good-ass-led-neon-sign": {"backboard":"Clear"},
  "bakery-led-neon-sign": {"colours":["Cold White","Orange","Lemon Yellow"],"backboard":"Clear"},
  "balaclava-ghost": {"backboard":"Clear"},
  "balloon-dog": {"backboard":"Clear"},
  "baltimore-american-football-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "baltimore-baseball-led-neon-sign": {"colours":["Cold White","Orange"],"backboard":"UV Print"},
  "banana-skin": {"colours":["Lemon Yellow","Cold White"],"backboard":"Clear"},
  "bar-martini-glass": {"backboard":"Clear"},
  "bar-open-1": {"colours":["Ice Blue","Pink","Lemon Yellow"],"backboard":"Clear"},
  "bar-open-2": {"colours":["Ice Blue","Purple"],"backboard":"Clear"},
  "barber-cut-led-neon-sign": {"colours":["Cold White","Blue","Red"],"backboard":"Clear"},
  "barber-led-neon-sign": {"colours":["Pink","Red","Lemon Yellow","Ice Blue","Cold White","Green"],"backboard":"Clear"},
  "barber-pole-led-neon-sign": {"colours":["Cold White","Ice Blue","Red"],"backboard":"Clear"},
  "barbers-led-neon-sign": {"colours":["Blue","Lemon Yellow","Red"],"backboard":"Clear"},
  "barbershop-led-neon-sign": {"colours":["Blue","Red","Cold White"],"backboard":"Clear"},
  "barbershop-led-neon-sign-1": {"backboard":"Clear"},
  "barbershop-precision-led-neon-sign": {"colours":["Cold White","Blue","Pink"],"backboard":"Clear"},
  "bars-open-palm-trees": {"colours":["Green","Pink","Lemon Yellow","Ice Blue"],"backboard":"Clear"},
  "bart-led-neon-sign": {"colours":["Lemon Yellow","Red","Cold White"],"backboard":"Clear"},
  "baseball": {"backboard":"Clear"},
  "basketball": {"backboard":"UV Print"},
  "batman-led-neon-sign": {"colours":["White"],"backboard":"UV Print"},
  "bauble": {"colours":["Pink","Cold White"],"backboard":"Clear"},
  "be-happy-lift-heavy-led-neon-sign": {"colours":["Lemon Yellow","Green","Cold White","Orange"],"backboard":"Clear"},
  "be-merry": {"colours":["Cold White","Green","Red"],"backboard":"Clear"},
  "be-my-flower-led-neon-sign": {"backboard":"Clear"},
  "be-my-valentine-potion": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "be-naked-when-i-get-home": {"backboard":"UV Print"},
  "beast-mode-led-neon-sign": {"backboard":"Clear"},
  "beauty-salon-led-neon-sign": {"backboard":"Clear"},
  "because-love-led-neon-sign": {"backboard":"Clear"},
  "bed-sheet-ghost": {"backboard":"Clear"},
  "beer-can-led-neon-sign": {"colours":["Cold White","Lemon Yellow","Green"],"backboard":"UV Print"},
  "beer-cup": {"colours":["Golden Yellow","Cold White"],"backboard":"Clear"},
  "beer-led-neon-sign": {"colours":["Orange","Cold White","Ice Blue"],"backboard":"Clear"},
  "better-together-led-neon-sign": {"backboard":"Clear"},
  "better-together-led-neon-sign-1": {"backboard":"Clear"},
  "biggie-smalls-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "bingo-led-neon-sign": {"colours":["Cold White","Red","Orange","Pink","Ice Blue","Purple"],"backboard":"Clear"},
  "birds-of-paradise-led-neon-sign": {"backboard":"Clear"},
  "bitcoin": {"backboard":"Clear"},
  "bitcoin-accepted-here": {"colours":["Lemon Yellow","Cold White"],"backboard":"Clear"},
  "blades-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"UV Print"},
  "blanco-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue"],"backboard":"UV Print"},
  "blaugrana-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Ice Blue","Pink","Red"],"backboard":"UV Print"},
  "blessed-led-neon-sign": {"backboard":"Clear"},
  "block-wm-toilets": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "blossoming-flower-led-neon-sign": {"colours":["Cold White","Purple"],"backboard":"Clear"},
  "blossoming-flower-led-neon-sign-copy": {"colours":["Cold White","Pink"],"backboard":"UV Print"},
  "blues-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"UV Print"},
  "blues-led-neon-sign-1": {"colours":["Ice Blue","Blue","Lemon Yellow"],"backboard":"UV Print"},
  "boo-ghost-led-neon-sign": {"colours":["Ice Blue","Pink","Green","Cold White","Lemon Yellow"],"backboard":"Clear"},
  "booo": {"backboard":"Clear"},
  "booo-1": {"backboard":"Clear"},
  "boston-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "boston-hockey-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "boston-led-neon-sign": {"colours":["Cold White","Green","Orange"],"backboard":"Clear"},
  "box-of-noodles-led-neon-sign": {"colours":["Ice Blue","Lemon Yellow","Purple","Red"],"backboard":"Clear"},
  "boxing-gloves-led-neon-sign": {"colours":["Red","White"],"backboard":"Clear"},
  "boxing-gorilla-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"UV Print"},
  "boy-or-girl": {"colours":["Ice Blue","Pink","Cold White"],"backboard":"Clear"},
  "boys-boys-boys": {"backboard":"Clear"},
  "breasts": {"colours":["Warm White","Pink"],"backboard":"Clear"},
  "breathe-led-neon-sign": {"backboard":"Clear"},
  "bride-to-be-led-neon-sign": {"backboard":"Clear"},
  "broken-heart": {"backboard":"Clear"},
  "bucks-led-neon-sign": {"backboard":"Clear"},
  "buffalo-american-football-led-neon-sign": {"colours":["Blue","Red"],"backboard":"UV Print"},
  "buffalo-hockey-led-neon-sign-copy": {"colours":["Cold White","Lemon Yellow"],"backboard":"UV Print"},
  "buffalo-lacrosse-team-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "bulldog-led-neon-sign": {"backboard":"UV Print"},
  "bulldogs-led-neon-sign": {"backboard":"UV Print"},
  "bulls-23-led-neon-sign": {"backboard":"Clear"},
  "bulls-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "bulls-led-neon-sign-1": {"colours":["Red","White"],"backboard":"Clear"},
  "bunny-boy-drip": {"backboard":"Clear"},
  "burger-1": {"colours":["Lemon Yellow","Pink","Green","Cold White"],"backboard":"Clear"},
  "burger-2": {"colours":["Lemon Yellow","Cold White","Green"],"backboard":"Clear"},
  "but-coffee-first-led-neon-sign": {"backboard":"Clear"},
  "but-first-coffee-led-neon-sign-1": {"backboard":"Clear"},
  "but-first-makeup": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "but-first-nails-led-neon-sign": {"backboard":"Clear"},
  "butterfly-led-neon-sign": {"colours":["Golden Yellow","Green","Pink"],"backboard":"Clear"},
  "cactus-led-neon-sign": {"colours":["Green","Orange"],"backboard":"Clear"},
  "calgary-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "can-you-sing-led-neon-sign": {"colours":["Cold White","Pink","Ice Blue"],"backboard":"Clear"},
  "canine-led-neon-sign": {"backboard":"Clear"},
  "carolina-american-football-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "cartoon-girl-led-neon-sign": {"backboard":"Clear"},
  "cash-king-led-neon-sign": {"colours":["Green","Orange"],"backboard":"UV Print"},
  "cat-in-the-night-led-neon-sign": {"colours":["Red","Pink","Orange"],"backboard":"Clear"},
  "cats-dogs": {"colours":["Blue","Red"],"backboard":"Clear"},
  "cava-led-neon-sign": {"colours":["Golden Yellow","Red"],"backboard":"UV Print"},
  "cc-drip": {"backboard":"Clear"},
  "cfc": {"colours":["White"],"backboard":"Clear"},
  "champagne-led-neon-sign-1": {"backboard":"Clear"},
  "chariza-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Red"],"backboard":"UV Print"},
  "charlotte-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "check-my-nails-led-neon-sign": {"backboard":"Clear"},
  "cheers-led-neon-sign": {"backboard":"Clear"},
  "cheers-to-love-led-neon-sign": {"backboard":"Clear"},
  "chefs-hat-led-neon-sign": {"backboard":"Clear"},
  "cherries": {"colours":["Red","Green"],"backboard":"Clear"},
  "cherries-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "chicago-american-football-led-neon-sign": {"colours":["Orange"],"backboard":"UV Print"},
  "chicago-baseball-led-neon-sign": {"colours":["Blue","Red"],"backboard":"UV Print"},
  "chicago-c-american-football-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "chicago-soccer-team-led-neon-sign": {"colours":["Ice Blue","Red"],"backboard":"UV Print"},
  "chicago-ws-baseball-led-neon-sign": {"colours":["Cold White"],"backboard":"Clear"},
  "chill-pill-led-neon-sign": {"colours":["Ice Blue","Red","Lemon Yellow"],"backboard":"Clear"},
  "chop-it-like-its-hot-led-neon-sign-1": {"backboard":"Clear"},
  "christmas-stocking": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "christmas-tree": {"backboard":"Clear"},
  "chubby-bunny-ears-led-neon-sign": {"backboard":"Clear"},
  "chubby-squirrel-led-neon-sign": {"colours":["Ice Blue","Cold White","Golden Yellow","Purple","Green","Pink"],"backboard":"Clear"},
  "cincinnati-american-football-led-neon-sign": {"colours":["Orange"],"backboard":"UV Print"},
  "cincinnati-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "cincinnati-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "clean-cut-led-neon-sign": {"backboard":"Clear"},
  "cleveland-american-football-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "cleveland-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "closed": {"backboard":"Clear"},
  "closed-boxed": {"backboard":"Clear"},
  "closed-neon": {"colours":["Ice Blue","Green"],"backboard":"Clear"},
  "cloud-9-led-neon-sign": {"backboard":"Clear"},
  "cocaine-bear-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Red"],"backboard":"UV Print"},
  "cocaine-bear-led-neon-sign-1": {"colours":["Ice Blue","Pink"],"backboard":"UV Print"},
  "coffee-cup-led-neon-sign": {"colours":["Lemon Yellow","Cold White"],"backboard":"Clear"},
  "coffee-led-neon-sign": {"backboard":"Clear"},
  "cold-beer-led-neon-sign": {"backboard":"Clear"},
  "colorado-baseball-led-neon-sign": {"colours":["Cold White"],"backboard":"Clear"},
  "colorado-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "colorado-soccer-team-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "colourful-karaoke-led-neon-sign": {"colours":["Pink","Blue","Golden Yellow","Green","Orange","Red"],"backboard":"Clear"},
  "colourful-rose-bud": {"colours":["Red","Green"],"backboard":"Clear"},
  "cool-banana-led-neon-sign": {"colours":["Lemon Yellow","Green","Cold White"],"backboard":"Clear"},
  "cool-bulldog-led-neon-sign": {"backboard":"Clear"},
  "cool-pig-led-neon-sign": {"colours":["Orange","Ice Blue"],"backboard":"Clear"},
  "cool-pineapple-led-neon-sign": {"colours":["Lemon Yellow","Green","Cold White","Red"],"backboard":"Clear"},
  "coors-light-led-neon-sign": {"colours":["Ice Blue","Red"],"backboard":"UV Print"},
  "copy-of-angel-wings-led-neon-sign-1": {"colours":["Cold White","Ice Blue","Blue","Pink"],"backboard":"Clear"},
  "copy-of-i-got-99-problems-but-my-nails-aint-one-led-neon-sign": {"backboard":"Clear"},
  "copy-of-it-was-always-you-love-led-neon-sign": {"backboard":"Clear"},
  "copy-of-the-one-whom-my-soul-loves-led-neon-sign": {"backboard":"Clear"},
  "copy-of-wedding-led-neon-sign": {"backboard":"Clear"},
  "corona-in-paradise-led-neon-sign": {"colours":["Blue","Red","Green","Orange","Lemon Yellow"],"backboard":"Clear"},
  "corona-led-neon-sign": {"colours":["Lemon Yellow","Green"],"backboard":"UV Print"},
  "cowboy-led-neon-sign": {"backboard":"Clear"},
  "crazy-in-love-led-neon-sign": {"backboard":"Clear"},
  "crocodile-led-neon-sign": {"colours":["Green","Cold White","Lemon Yellow"],"backboard":"UV Print"},
  "croissant-led-neon-sign": {"backboard":"Clear"},
  "crowned-heart-drip": {"colours":["Red","Lemon Yellow"],"backboard":"Clear"},
  "cup-cake-led-neon-sign": {"colours":["Pink","Cold White"],"backboard":"UV Print"},
  "cup-cake-led-neon-sign-1": {"colours":["Golden Yellow","Pink"],"backboard":"Clear"},
  "cupid": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "cut-throat-led-neon-sign": {"colours":["Cold White","Ice Blue","Warm White"],"backboard":"Clear"},
  "cwood-magpies-1": {"backboard":"Clear"},
  "d-c-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "dallas-american-football-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "dallas-soccer-team-led-neon-sign": {"colours":["Red","Cold White"],"backboard":"UV Print"},
  "dance-to-my-own-beat-led-neon-sign": {"colours":["Pink","Ice Blue","Cold White"],"backboard":"Clear"},
  "danger-kangaroos-led-neon-sign": {"backboard":"Clear"},
  "dangling-bauble": {"colours":["Green","Red","Cold White"],"backboard":"Clear"},
  "day-for-it-led-neon-sign": {"backboard":"Clear"},
  "day-of-the-dead-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Pink","Green","Purple","Orange"],"backboard":"Clear"},
  "day-of-the-dead-led-neon-sign-1": {"colours":["Green","Cold White","Pink","Orange","Ice Blue","Lemon Yellow"],"backboard":"Clear"},
  "deadmaus": {"colours":["Blue","Pink","Ice Blue","Cold White","Purple"],"backboard":"Clear"},
  "delightful-easter-led-neon-sign": {"colours":["Purple","Ice Blue","Pink","Lemon Yellow"],"backboard":"Clear"},
  "demon-slice-led-neon-sign": {"colours":["Green","Red","Lemon Yellow"],"backboard":"UV Print"},
  "demons-led-neon-sign": {"backboard":"Clear"},
  "denver-american-football-led-neon-sign": {"colours":["Cold White","Orange"],"backboard":"UV Print"},
  "detroit-american-football-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "detroit-baseball-led-neon-sign": {"colours":["Blue"],"backboard":"Clear"},
  "diamomd": {"backboard":"UV Print"},
  "dj-decks": {"backboard":"Clear"},
  "do-fun-shit-led-neon-sign": {"backboard":"Clear"},
  "dockers-led-neon-sign": {"backboard":"Clear"},
  "dog-love-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"Clear"},
  "dog-partner-led-neon-sign": {"colours":["Golden Yellow","Blue","Red","Lemon Yellow"],"backboard":"Clear"},
  "dogs-can-skii-led-neon-sign": {"colours":["Orange","Red","Cold White"],"backboard":"Clear"},
  "dollar-sign": {"backboard":"Clear"},
  "dont-quit-led-neon-sign": {"colours":["White","Pink"],"backboard":"Clear"},
  "dont-tell-me-what-to-do-led-neon-sign": {"backboard":"Clear"},
  "donut-led-neon-sign": {"colours":["Ice Blue","Lemon Yellow","Purple"],"backboard":"Clear"},
  "donut-open-led-neon-sign-1": {"colours":["Ice Blue","Pink","Lemon Yellow","Green","Red","Blue"],"backboard":"Clear"},
  "double-scoop-ice-cream-led-neon-sign": {"colours":["Blue","Lemon Yellow","Purple"],"backboard":"Clear"},
  "dragon-led-neon-sign": {"backboard":"Clear"},
  "dragon-stars-led-neon-sign": {"colours":["Lemon Yellow","Red"],"backboard":"Clear"},
  "dream-big-led-neon-sign": {"backboard":"Clear"},
  "drinking-you-dry-led-neon-sign": {"colours":["Pink","Green","Lemon Yellow","Cold White"],"backboard":"Clear"},
  "drunk-in-love-heart-led-neon-sign": {"backboard":"Clear"},
  "drunk-in-love-led-neon-sign": {"backboard":"Clear"},
  "drunk-in-love-led-neon-sign-1": {"backboard":"Clear"},
  "eagles-led-neon-sign": {"colours":["Blue","Red","Cold White"],"backboard":"UV Print"},
  "easter-egg-led-neon-sign": {"colours":["Lemon Yellow","Pink","Ice Blue"],"backboard":"Clear"},
  "eat-clean-train-dirty-led-neon-sign": {"backboard":"Clear"},
  "eat-drink-dance-led-neon-sign": {"backboard":"Clear"},
  "eat-sleep-game-repeat-led-neon-sign": {"colours":["Orange","Blue","Lemon Yellow","Red"],"backboard":"Clear"},
  "eat-sleep-gym-repeat-led-neon-sign": {"colours":["Cold White","Purple"],"backboard":"Clear"},
  "eat-sleep-lift-repeat-led-neon-sign": {"backboard":"UV Print"},
  "eat-what-makes-you-happy-led-neon-sign": {"backboard":"Clear"},
  "engaged-led-neon-sign": {"backboard":"Clear"},
  "enter-exit": {"colours":["Ice Blue","Red"],"backboard":"Clear"},
  "enter-running-man": {"backboard":"Clear"},
  "ess-bombers-1": {"colours":["White","Red"],"backboard":"Clear"},
  "ess-bombers-badge": {"colours":["Red","Cold White"],"backboard":"UV Print"},
  "everyday-im-hustling": {"backboard":"Clear"},
  "exit-running-man": {"backboard":"Clear"},
  "extra-flop-bunny-ears-led-neon-sign": {"backboard":"Clear"},
  "f-you-led-neon-sign": {"backboard":"Clear"},
  "father-christmas": {"colours":["Pink","Red"],"backboard":"Clear"},
  "father-xmas": {"colours":["Cold White","Red","Lemon Yellow"],"backboard":"Clear"},
  "feed-me-tacos-led-neon-sign-2": {"backboard":"Clear"},
  "female-left-male-right": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "fill-my-glass-led-neon-sign": {"backboard":"Clear"},
  "find-your-glow-led-neon-sign": {"backboard":"Clear"},
  "fine-and-dined-nails": {"backboard":"Clear"},
  "finished-nails-led-neon-sign": {"backboard":"Clear"},
  "flamingo-led-neon-sign": {"colours":["Purple","Orange","Blue","Ice Blue"],"backboard":"Clear"},
  "florist-led-neon-sign": {"colours":["Red","Lemon Yellow","Green","Purple","Cold White"],"backboard":"Clear"},
  "florist-open-led-neon-sign": {"colours":["Purple","Red","Green","Lemon Yellow"],"backboard":"Clear"},
  "flower-led-neon-sign": {"colours":["Green","Purple"],"backboard":"Clear"},
  "flower-shop-led-neon-sign": {"colours":["Green","Pink","Cold White"],"backboard":"Clear"},
  "flowerheads-led-neon-sign": {"colours":["Cold White","Ice Blue","Pink","Lemon Yellow"],"backboard":"Clear"},
  "flush-led-neon-sign": {"backboard":"Clear"},
  "flying-goka-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Red","Cold White"],"backboard":"Clear"},
  "for-life-led-neon-sign": {"backboard":"Clear"},
  "forest-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "forever-and-always-led-neon-sign-1": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "fortnite-led-neon-sign": {"backboard":"Clear"},
  "fremantle-led-neon-sign": {"backboard":"UV Print"},
  "fresh-fruit-led-neon-sign": {"colours":["Green","Orange","Red"],"backboard":"Clear"},
  "fried-chicken-led-neon-sign-1": {"colours":["Orange","Red","Cold White"],"backboard":"Clear"},
  "frozen-cone-led-neon-sign": {"backboard":"Clear"},
  "funky-no-place-like-home": {"backboard":"Clear"},
  "game-on-led-neon-sign": {"backboard":"Clear"},
  "game-over-led-neon-sign": {"colours":["Red","Orange","Cold White"],"backboard":"Clear"},
  "game-over-led-neon-sign-1": {"backboard":"Clear"},
  "game-zone-led-neon-sign": {"backboard":"Clear"},
  "geelong-led-neon-sign": {"backboard":"UV Print"},
  "gelato-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Green","Pink"],"backboard":"Clear"},
  "genga-led-neon-sign": {"colours":["Purple","Cold White","Red"],"backboard":"Clear"},
  "georgia-lacrosse-team-led-neon-sign": {"colours":["Golden Yellow","Warm White"],"backboard":"UV Print"},
  "get-naked-led-neon-sign": {"backboard":"Clear"},
  "ghost-1": {"backboard":"Clear"},
  "ginger-bread-man": {"colours":["Lemon Yellow","Cold White","Ice Blue"],"backboard":"Clear"},
  "girls-girls-girls": {"backboard":"Clear"},
  "giveaway": {"backboard":"Clear"},
  "giveaway-layers": {"colours":["Pink","Golden Yellow"],"backboard":"Clear"},
  "glass-half-full-led-neon-sign": {"backboard":"Clear"},
  "go-10-led-neon-sign": {"colours":["Ice Blue","Cold White","Blue","Orange"],"backboard":"UV Print"},
  "goal-digger-led-neon-sign": {"backboard":"Clear"},
  "goka-art-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Blue"],"backboard":"UV Print"},
  "goka-led-neon-sign": {"colours":["Orange","Cold White"],"backboard":"Clear"},
  "goke-led-neon-sign": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "gold-coast-led-neon-sign": {"backboard":"Clear"},
  "good-food-good-mood-good-vibe-led-neon-sign": {"backboard":"Clear"},
  "good-food-good-mood-led-neon-sign": {"backboard":"Clear"},
  "good-food-led-neon-sign": {"colours":["Cold White","Lemon Yellow","Green","Red"],"backboard":"Clear"},
  "good-hair-day-led-neon-sign": {"backboard":"Clear"},
  "good-vibes-led-neon-sign": {"colours":["Cold White","Ice Blue"],"backboard":"Clear"},
  "good-vibes-only-led-neon-sign": {"backboard":"Clear"},
  "gorilla-led-neon-sign": {"colours":["Pink","Ice Blue"],"backboard":"UV Print"},
  "gramophone-led-neon-sign": {"colours":["Red","Cold White","Lemon Yellow"],"backboard":"Clear"},
  "green-bay-american-football-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "guiness": {"colours":["Yellow","White"],"backboard":"Clear"},
  "guitar-music-led-neon-sign": {"backboard":"Clear"},
  "gunners-led-neon-sign": {"colours":["Lemon Yellow","Pink","Cold White"],"backboard":"UV Print"},
  "gws-led-neon-sign": {"backboard":"Clear"},
  "gym-mode-led-neon-sign": {"colours":["Blue","Ice Blue","Cold White"],"backboard":"Clear"},
  "halifax-lacrosse-team-led-neon-sign": {"colours":["Cold White","Orange"],"backboard":"UV Print"},
  "halloween": {"backboard":"Clear"},
  "halo-angel-wings-led-neon-sign": {"backboard":"Clear"},
  "handsy-led-neon-sign": {"backboard":"Clear"},
  "happily-ever-after-led-neon-sign": {"backboard":"Clear"},
  "happily-ever-after-led-neon-sign-1": {"backboard":"Clear"},
  "happy-birthday-led-neon-sign": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "happy-birthday-led-neon-sign-1": {"colours":["Ice Blue","Cold White","Pink","Green","Purple","Red","Lemon Yellow","Orange"],"backboard":"Clear"},
  "happy-birthday-led-neon-sign-2": {"backboard":"Clear"},
  "happy-birthday-led-neon-sign-3": {"backboard":"Clear"},
  "happy-easter-bunny-ears-led-neon-sign": {"backboard":"Clear"},
  "happy-easter-kids-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"Clear"},
  "happy-easter-kids-led-neon-sign-1": {"colours":["Cold White","Pink","Lemon Yellow","Green"],"backboard":"Clear"},
  "happy-easter-led-neon-sign": {"backboard":"Clear"},
  "happy-easter-rabbit-led-neon-sign": {"colours":["Orange","Ice Blue"],"backboard":"Clear"},
  "happy-hearts": {"backboard":"Clear"},
  "happy-hour-led-neon-sign": {"colours":["Pink","Green","Lemon Yellow"],"backboard":"Clear"},
  "happy-reindeer": {"backboard":"Clear"},
  "happy-rudolph": {"colours":["Lemon Yellow","Cold White","Red"],"backboard":"Clear"},
  "happy-santa": {"backboard":"Clear"},
  "happy-valentines-day": {"backboard":"Clear"},
  "have-a-slice-day-led-neon-sign": {"colours":["Cold White","Lemon Yellow","Red","Orange","Green"],"backboard":"Clear"},
  "hawks-led-neon-sign": {"backboard":"Clear"},
  "headphones": {"backboard":"Clear"},
  "heart": {"backboard":"Clear"},
  "heart-click": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "heart-family": {"backboard":"Clear"},
  "heat-led-neon-sign": {"colours":["Red","Cold White","Lemon Yellow"],"backboard":"Clear"},
  "hell-here-hello-there": {"backboard":"Clear"},
  "hello-gorgeous": {"backboard":"Clear"},
  "hello-gorgeous-2": {"backboard":"Clear"},
  "hello-gorgeous-3": {"backboard":"Clear"},
  "hello-gorgeous-4": {"backboard":"Clear"},
  "hello-gorgeous-5": {"backboard":"Clear"},
  "hello-gorgeous-6": {"backboard":"Clear"},
  "hello-seventy-led-neon-sign": {"backboard":"Clear"},
  "hello-thirty-led-neon-sign": {"backboard":"Clear"},
  "hey-babe-nice-brows-led-neon-sign": {"backboard":"Clear"},
  "hipster-saint-nick": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "ho-ho-ho": {"backboard":"Clear"},
  "ho-ho-ho-antlers": {"backboard":"Clear"},
  "ho-ho-ho-bold": {"backboard":"Clear"},
  "home-is-where-the-good-vibes-are-led-neon-sign": {"colours":["Pink","Green"],"backboard":"Clear"},
  "home-sweet-home-led-neon-sign": {"backboard":"Clear"},
  "home-sweet-home-led-neon-sign-1": {"backboard":"Clear"},
  "hookah-led-neon-sign": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "hot-coffee-cup": {"backboard":"Clear"},
  "hot-pizza-led-neon-sign": {"colours":["Lemon Yellow","Orange","Red"],"backboard":"Clear"},
  "houston-american-football-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"UV Print"},
  "houston-baseball-led-neon-sign": {"colours":["Orange","Cold White"],"backboard":"UV Print"},
  "houston-soccer-team-led-neon-sign": {"colours":["Orange"],"backboard":"UV Print"},
  "hungry-astronaut-led-neon-sign": {"colours":["Orange","Cold White","Lemon Yellow"],"backboard":"UV Print"},
  "hungry-bunny-led-neon-sign": {"colours":["Cold White","Purple","Orange","Green"],"backboard":"Clear"},
  "hungry-wombat-led-neon-sign": {"colours":["Orange","Pink","Blue"],"backboard":"Clear"},
  "hustle": {"backboard":"Clear"},
  "i-got-99-problems-but-my-nails-aint-one-led-neon-sign": {"backboard":"Clear"},
  "i-licked-it-so-its-mine": {"backboard":"Clear"},
  "i-love-you-i-know-led-neon-sign": {"backboard":"Clear"},
  "i-think-better-when-im-not-sober-led-neon-sign": {"backboard":"Clear"},
  "i-will-cut-you-led-neon-sign": {"backboard":"Clear"},
  "ice-cold-tongue-led-neon-sign": {"colours":["Ice Blue","White"],"backboard":"UV Print"},
  "ice-cream-cone": {"colours":["Golden Yellow","Purple","Ice Blue","Green"],"backboard":"Clear"},
  "ice-cream-cone-led-neon-sign": {"colours":["Warm White","Purple","Ice Blue"],"backboard":"Clear"},
  "ice-cream-led-neon-sign": {"colours":["Pink","Warm White"],"backboard":"Clear"},
  "ice-cream-led-neon-sign-1": {"colours":["Cold White","Pink","Lemon Yellow"],"backboard":"Clear"},
  "ice-cream-solves-everything-led-neon-sign": {"colours":["Ice Blue","Warm White","Green","Pink","Red"],"backboard":"Clear"},
  "ice-polar-led-neon-sign": {"colours":["Ice Blue"],"backboard":"UV Print"},
  "ice-skates": {"colours":["Ice Blue","Cold White","Purple"],"backboard":"Clear"},
  "in-the-palm-of-my-hands-led-neon-sign": {"backboard":"Clear"},
  "indianapolis-american-football-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "inhale-exhale-led-neon-sign": {"backboard":"Clear"},
  "initials-led-neon-sign": {"backboard":"Clear"},
  "inter-miami-soccer-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "irish-beard": {"colours":["Green","Orange","Cold White","Lemon Yellow"],"backboard":"Clear"},
  "irish-pub-led-neon-sign": {"colours":["Cold White","Green"],"backboard":"Clear"},
  "irons-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Cold White"],"backboard":"UV Print"},
  "is-this-art-led-neon-sign": {"colours":["Ice Blue","Pink"],"backboard":"UV Print"},
  "it-was-all-a-dream-led-neoin-sign": {"backboard":"Clear"},
  "it-was-always-you-led-neon-sign": {"backboard":"Clear"},
  "it-was-always-you-led-neon-sign-1": {"backboard":"Clear"},
  "it-was-always-you-led-neon-sign-2": {"backboard":"Clear"},
  "it-was-always-you-love-led-neon-sign": {"backboard":"Clear"},
  "its-a-good-day-to-make-music-led-neon-sign": {"colours":["Red","Green"],"backboard":"Clear"},
  "its-glow-time-led-neon-sign": {"backboard":"Clear"},
  "its-lash-oclock-led-neon-sign": {"backboard":"Clear"},
  "jack-daniels-led-neon-sign": {"backboard":"Clear"},
  "jacksonville-american-football-led-neon-sign": {"colours":["Golden Yellow"],"backboard":"UV Print"},
  "jamesons-whiskey": {"colours":["Green","Cold White"],"backboard":"Clear"},
  "jelly-fish-led-neon-sign": {"backboard":"Clear"},
  "jolly-rudolph": {"colours":["Lemon Yellow","Cold White","Red"],"backboard":"Clear"},
  "jolly-santa": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "juicy-lips-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "jumpman": {"backboard":"Clear"},
  "just-married-led-neon-sign": {"backboard":"Clear"},
  "just-married-led-neon-sign-1": {"backboard":"Clear"},
  "kansas-baseball-led-neon-sign": {"colours":["Blue"],"backboard":"Clear"},
  "kansas-city-american-football-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "kansas-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "karaoke-frog-led-neon-sign": {"colours":["Green","Cold White","Orange"],"backboard":"Clear"},
  "karaoke-led-neon-sign": {"backboard":"Clear"},
  "karaoke-led-neon-sign-1": {"backboard":"Clear"},
  "karaoke-night-led-neon-sign": {"colours":["Purple","Orange","Green","Blue"],"backboard":"Clear"},
  "karaoke-party-led-neon-sign": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "kebab-led-neon-sign": {"colours":["Orange","Cold White","Red"],"backboard":"Clear"},
  "keep-calm-and-smoke-shisha-led-neon-sign": {"backboard":"Clear"},
  "killer-duck-led-neon-sign": {"colours":["Cold White","Golden Yellow","Red","Blue"],"backboard":"Clear"},
  "king-and-queen-of-hearts": {"colours":["White","Red"],"backboard":"Clear"},
  "kingfish-led-neon-sign": {"colours":["Orange","Blue","Cold White","Warm White"],"backboard":"Clear"},
  "kiss-me-led-neon-sign": {"backboard":"Clear"},
  "kitty-cat-led-neon-sign": {"backboard":"Clear"},
  "la-soccer-team-led-neon-sign": {"colours":["Lemon Yellow","Cold White"],"backboard":"UV Print"},
  "lakers": {"colours":["Blue","Orange"],"backboard":"Clear"},
  "las-vegas-american-football-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "las-vegas-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "lash-room-led-neon-sign": {"backboard":"Clear"},
  "lashes-led-neon-sign": {"backboard":"Clear"},
  "lazy-cat-led-neon-sign": {"backboard":"Clear"},
  "leprachaun": {"colours":["Green"],"backboard":"UV Print"},
  "lets-drink-lets-eat-lets-talk-led-neon-sign-1": {"backboard":"Clear"},
  "lets-get-wild-for-a-while-led-neon-sign": {"backboard":"Clear"},
  "lets-play-led-neon-sign": {"colours":["Ice Blue","Purple"],"backboard":"Clear"},
  "lets-stay-home": {"backboard":"Clear"},
  "lets-taco-about-led-neon-sign": {"colours":["Lemon Yellow","Green","Red","Pink","Purple","Blue"],"backboard":"Clear"},
  "level-up-led-neon-sign": {"colours":["Warm White","Cold White"],"backboard":"Clear"},
  "lifes-a-party-dress-like-it-led-neon-sign": {"backboard":"Clear"},
  "lion-led-neon-sign": {"colours":["Orange","Lemon Yellow"],"backboard":"UV Print"},
  "live-guitar-led-neon-sign": {"colours":["Cold White","Orange","Green"],"backboard":"Clear"},
  "live-music-here-led-neon-sign": {"colours":["Orange","Ice Blue","Red"],"backboard":"Clear"},
  "live-music-led-neon-sign": {"colours":["Red","Cold White","Ice Blue"],"backboard":"Clear"},
  "live-music-notes-led-neon-sign": {"colours":["Orange","Blue","Pink"],"backboard":"Clear"},
  "los-angeles-american-football-led-neon-sign": {"colours":["Blue","Lemon Yellow"],"backboard":"UV Print"},
  "los-angeles-american-football-led-neon-sign-1": {"colours":["Golden Yellow"],"backboard":"UV Print"},
  "los-angeles-baseball-led-neon-sign": {"colours":["Red","Blue"],"backboard":"UV Print"},
  "los-angeles-d-baseball-led-neon-sign": {"colours":["Blue"],"backboard":"Clear"},
  "los-angeles-soccer-team-led-neon-sign": {"colours":["Orange"],"backboard":"UV Print"},
  "love-heart": {"backboard":"Clear"},
  "love-is-in-the-hair-led-neon-sign": {"backboard":"Clear"},
  "love-led-neon-sign": {"backboard":"Clear"},
  "love-made-us-do-it-led-neon-sign": {"backboard":"Clear"},
  "luck-of-the-irish-led-neon-sign": {"backboard":"Clear"},
  "luigi-led-neon-sign": {"colours":["Lemon Yellow","Green"],"backboard":"UV Print"},
  "m-c-f-c": {"colours":["Ice Blue"],"backboard":"Clear"},
  "magaritas-led-neon-sign": {"colours":["Cold White","Red","Ice Blue","Green","Lemon Yellow"],"backboard":"Clear"},
  "magaritas-led-neon-sign-1": {"backboard":"Clear"},
  "magic-fish-led-neon-sign": {"colours":["Red","Cold White","Lemon Yellow","Orange","Pink"],"backboard":"Clear"},
  "magic-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"Clear"},
  "magic-star-led-neon-sign": {"backboard":"Clear"},
  "magpies-led-neon-sign": {"colours":["Golden Yellow","Cold White","Ice Blue","Red"],"backboard":"UV Print"},
  "makeover-led-neon-sign": {"backboard":"Clear"},
  "male-left-female-right": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "man-cave": {"backboard":"Clear"},
  "man-on-the-moon-led-neon-sign": {"colours":["Cold White","Purple","Lemon Yellow"],"backboard":"UV Print"},
  "man-on-the-moon-led-neon-sign-1": {"colours":["Ice Blue","Lemon Yellow","Orange"],"backboard":"UV Print"},
  "manchester-united-logo": {"colours":["Ice Blue","Lemon Yellow","Cold White","Red"],"backboard":"Clear"},
  "manchester-united-logo-1": {"colours":["Yellow","Red","Orange"],"backboard":"UV Print"},
  "manicure-and-pedicure-led-neon-sign": {"backboard":"Clear"},
  "mario-led-neon-sign": {"colours":["Cold White","Blue","Red"],"backboard":"UV Print"},
  "marry-me": {"backboard":"Clear"},
  "martini-glass": {"colours":["Blue","Green","Pink"],"backboard":"Clear"},
  "meant-to-be-heart-led-neon-sign": {"backboard":"Clear"},
  "meditating-led-neon-sign": {"backboard":"Clear"},
  "mens-left-womens-right": {"colours":["Pink","Ice Blue","Lemon Yellow","Cold White"],"backboard":"Clear"},
  "merry-christmas": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "merry-christmas-bauble": {"colours":["Red","Ice Blue"],"backboard":"Clear"},
  "mew-led-neon-sign": {"colours":["Pink"],"backboard":"UV Print"},
  "mexicano-led-neon-sign": {"colours":["Green","Red","Cold White","Ice Blue"],"backboard":"Clear"},
  "miami-american-football-led-neon-sign": {"colours":["Ice Blue","Red"],"backboard":"UV Print"},
  "miami-baseball-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "microphone-led-neon-sign": {"colours":["Cold White","Blue"],"backboard":"Clear"},
  "milkshake": {"colours":["Purple","Cold White","Red"],"backboard":"Clear"},
  "milkshake-burger-led-neon-sign": {"colours":["Cold White","Orange","Ice Blue","Pink","Green","Red"],"backboard":"Clear"},
  "milwaukee-baseball-led-neon-sign": {"colours":["Golden Yellow"],"backboard":"UV Print"},
  "minimal-reindeer-led-neon-sign": {"backboard":"Clear"},
  "minnesota-american-football-led-neon-sign": {"colours":["Golden Yellow","Cold White","Purple"],"backboard":"UV Print"},
  "minnesota-baseball-led-neon-sign": {"colours":["Red","Blue"],"backboard":"Clear"},
  "minnesota-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "miss-poodle-led-neon-sign": {"colours":["Cold White","Purple"],"backboard":"Clear"},
  "miss-to-mrs-led-neon-sign": {"backboard":"Clear"},
  "money-bags-led-neon-sign": {"colours":["Green","Lemon Yellow"],"backboard":"UV Print"},
  "money-led-neon-sign": {"backboard":"Clear"},
  "montreal-soccer-team-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "mr-mrs-led-neon-sign": {"backboard":"Clear"},
  "mr-penguin-led-neon-sign": {"colours":["Cold White","Pink","Ice Blue","Lemon Yellow"],"backboard":"Clear"},
  "mr-whippy-led-neon-sign": {"colours":["Cold White","Lemon Yellow"],"backboard":"Clear"},
  "munich-led-neon-sign": {"colours":["Cold White","Ice Blue"],"backboard":"UV Print"},
  "muscle-gym-led-neon-sign": {"colours":["Orange","Cold White"],"backboard":"Clear"},
  "muscle-gym-led-neon-sign-1": {"backboard":"Clear"},
  "mushroom-led-neon-sign": {"colours":["Lemon Yellow"],"backboard":"UV Print"},
  "mushrooms-led-neon-sign": {"colours":["Green","Cold White","Pink"],"backboard":"Clear"},
  "music-led-neon-sign": {"backboard":"Clear"},
  "music-notes-led-neon-sign": {"colours":["Cold White","Red","Pink","Ice Blue","Lemon Yellow"],"backboard":"Clear"},
  "music-studio-led-neon-sign": {"colours":["Pink","Red","Ice Blue"],"backboard":"Clear"},
  "musical-note-led-neon-sign": {"backboard":"Clear"},
  "musical-skeleton-led-neon-sign": {"colours":["Cold White","Blue","Orange","Purple"],"backboard":"Clear"},
  "nail-sign-led-neon-sign": {"backboard":"Clear"},
  "nail-sign-led-neon-sign-1": {"backboard":"Clear"},
  "nails-before-males-led-neon-sign": {"backboard":"Clear"},
  "nails-nails-nails-led-neon-sign": {"backboard":"Clear"},
  "naked-anime-led-neon-sign": {"colours":["Ice Blue","Pink","Lemon Yellow","Cold White","Red"],"backboard":"Clear"},
  "naked-woman": {"backboard":"Clear"},
  "nashville-soccer-team-led-neon-sign": {"colours":["Lemon Yellow","Blue"],"backboard":"UV Print"},
  "naughty-gengis-led-neon-sign": {"colours":["Blue","Cold White","Red"],"backboard":"Clear"},
  "need-to-pee-toilet-characters": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "new-england-american-football-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "new-england-soccer-led-neon-sign": {"colours":["Blue","Red","Cold White"],"backboard":"UV Print"},
  "new-orleans-american-football-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "new-york-american-football-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "new-york-j-american-football-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "new-york-m-baseball-led-neon-sign": {"colours":["Orange"],"backboard":"Clear"},
  "new-york-soccer-team-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"UV Print"},
  "new-york-y-baseball-led-neon-sign": {"colours":["Blue"],"backboard":"Clear"},
  "no-boys-allowed": {"backboard":"Clear"},
  "no-girls-allowed": {"backboard":"Clear"},
  "no-music-no-life-led-neon-sign": {"backboard":"Clear"},
  "no-pain-no-gain-dumbbell-led-neon-sign": {"backboard":"Clear"},
  "no-pain-no-gain-led-neon-sign": {"colours":["Red","Ice Blue"],"backboard":"Clear"},
  "no-smoking-boxed": {"colours":["Red","Lemon Yellow"],"backboard":"Clear"},
  "no-smoking-old-school": {"backboard":"Clear"},
  "noodles-led-neon-sign": {"colours":["Pink","Lemon Yellow","Ice Blue"],"backboard":"Clear"},
  "normal-is-boring-led-neon-sign": {"backboard":"Clear"},
  "ny-led-neon-sign": {"colours":["Orange","Blue"],"backboard":"Clear"},
  "old-school-vinyl-deck": {"colours":["Red","Ice Blue","Orange"],"backboard":"Clear"},
  "on-air-1": {"backboard":"Clear"},
  "on-air-2": {"backboard":"Clear"},
  "on-air-led-neon-sign": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "on-the-air-1": {"backboard":"Clear"},
  "on-the-air-2": {"backboard":"Clear"},
  "on-the-air-3": {"backboard":"Clear"},
  "on-the-mic-karaoke-led-neon-sign": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "one-more-chapter-led-neon-sign": {"colours":["Cold White","Green","Ice Blue","Pink"],"backboard":"Clear"},
  "one-more-rep-led-neon-sign": {"backboard":"Clear"},
  "open-arrow": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "open-cafe-1": {"colours":["Lemon Yellow","Cold White","Red"],"backboard":"Clear"},
  "open-circled": {"backboard":"Clear"},
  "open-hanging": {"colours":["Ice Blue","Red"],"backboard":"Clear"},
  "open-massage": {"colours":["Red","Lemon Yellow","Green"],"backboard":"Clear"},
  "open-multicoloured": {"colours":["Purple","Lemon Yellow","Ice Blue","Orange"],"backboard":"Clear"},
  "open-noodles": {"colours":["Cold White","Lemon Yellow","Red"],"backboard":"Clear"},
  "open-orb": {"colours":["Red","Blue"],"backboard":"Clear"},
  "open-rainbow": {"colours":["Lemon Yellow","Ice Blue","Red","Green"],"backboard":"Clear"},
  "open-sign-boxed": {"backboard":"Clear"},
  "open-stars": {"colours":["Pink","Ice Blue","Lemon Yellow"],"backboard":"Clear"},
  "open-tacos-led-neon-sign": {"colours":["Green","Orange","Red","Ice Blue","Cold White"],"backboard":"Clear"},
  "orchid-led-neon-sign": {"colours":["Purple","Cold White","Golden Yellow"],"backboard":"Clear"},
  "orlando-soccer-team-led-neon-sign": {"colours":["Lemon Yellow","Cold White"],"backboard":"UV Print"},
  "oshawa-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "ottawa-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "pacers-led-neon-sign": {"colours":["Lemon Yellow","Blue"],"backboard":"Clear"},
  "pacman": {"colours":["Ice Blue","Red","Lemon Yellow"],"backboard":"Clear"},
  "paddy-hat": {"colours":["Green","Cold White","Lemon Yellow"],"backboard":"Clear"},
  "palm-tree": {"colours":["Green","Golden Yellow"],"backboard":"Clear"},
  "paradise-led-neon-sign": {"backboard":"Clear"},
  "paris-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "party-now-adult-later-led-neon-sign": {"backboard":"Clear"},
  "pasta-led-neon-sign": {"colours":["Lemon Yellow","Orange","Cold White"],"backboard":"Clear"},
  "peace-anime-girl-led-neon-sign": {"colours":["Purple","Pink","Cold White"],"backboard":"Clear"},
  "peace-out": {"backboard":"Clear"},
  "peach-led-neon-sign": {"colours":["Orange","Green"],"backboard":"Clear"},
  "peeking-toilet": {"colours":["Ice Blue","Pink","Lemon Yellow"],"backboard":"Clear"},
  "peeking-toilet-simple": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "penguin-roller-led-neon-sign": {"colours":["Blue","Cold White","Pink"],"backboard":"Clear"},
  "phila-led-neon-sign": {"colours":["Blue","Red"],"backboard":"Clear"},
  "philadelphia-american-football-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "philadelphia-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "philadelphia-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "philadelphia-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "piglet-led-neon-sign": {"backboard":"Clear"},
  "pika-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Red"],"backboard":"Clear"},
  "pilates": {"backboard":"Clear"},
  "pilates-led-neon-sign": {"backboard":"Clear"},
  "pineapple": {"colours":["Lemon Yellow","Green"],"backboard":"Clear"},
  "pittsburgh-american-football-led-neon-sign": {"colours":["Cold White","Lemon Yellow","Red","Blue"],"backboard":"UV Print"},
  "pittsburgh-baseball-led-neon-sign": {"colours":["Lemon Yellow"],"backboard":"Clear"},
  "pizza-drip-led-neon-sign": {"colours":["Lemon Yellow","Orange"],"backboard":"Clear"},
  "pizza-led-neon-sign": {"colours":["Orange","Red","Blue","Green","Lemon Yellow"],"backboard":"Clear"},
  "pizza-slice-led-neon-sign": {"colours":["Red","Lemon Yellow","Orange"],"backboard":"UV Print"},
  "plant-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Pink"],"backboard":"Clear"},
  "plant-pot-led-neon-sign": {"colours":["Green","Orange"],"backboard":"Clear"},
  "playboy-bunny": {"backboard":"Clear"},
  "playstation-controls": {"colours":["Green","Golden Yellow","Blue","Pink"],"backboard":"Clear"},
  "playstation-led-neon-sign": {"colours":["Red","Blue","Ice Blue","Yellow"],"backboard":"Clear"},
  "please-dont-do-coke-in-the-bathroom-led-neon-sign": {"backboard":"Clear"},
  "podcast-led-neon-sign": {"colours":["Purple","White","Ice Blue"],"backboard":"Clear"},
  "poke-ball-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "pop-eye-led-neon-sign": {"backboard":"Clear"},
  "port-football-club-led-neon-sign": {"backboard":"Clear"},
  "port-power-led-neon-sign": {"backboard":"Clear"},
  "portland-soccer-team-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "posing-led-neon-sign": {"backboard":"Clear"},
  "potters-led-neon-sign": {"colours":["Blue","Pink"],"backboard":"UV Print"},
  "pour-me-a-glass-led-neon-sign": {"backboard":"Clear"},
  "present": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "pulsing-heart": {"backboard":"Clear"},
  "puppy-eyes-led-neon-sign": {"backboard":"Clear"},
  "ramen-led-neon-sign": {"colours":["Ice Blue","Red","Cold White","Pink","Lemon Yellow"],"backboard":"Clear"},
  "record-store-led-neon-sign": {"colours":["Cold White","Ice Blue","Purple"],"backboard":"Clear"},
  "recording-led-neon-sign": {"backboard":"Clear"},
  "red-airmax": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "red-bull-ny-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "red-love": {"backboard":"Clear"},
  "reindeer": {"backboard":"Clear"},
  "reindeer-antlers-1": {"backboard":"Clear"},
  "relax-led-neon-sign": {"backboard":"Clear"},
  "revenge-of-monoply-led-neon-sign": {"colours":["Green","Pink"],"backboard":"UV Print"},
  "rich-tigers-1": {"colours":["Cold White","Lemon Yellow","Red"],"backboard":"Clear"},
  "rick-led-neon-sign": {"backboard":"Clear"},
  "rise-and-grind-led-neon-sign": {"backboard":"Clear"},
  "robot-bear-led-neon-sign": {"colours":["Pink","Cold White","Lemon Yellow"],"backboard":"UV Print"},
  "rochester-lacrosse-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "rock-and-roll-bunny-led-neon-sign": {"colours":["Cold White","Purple"],"backboard":"Clear"},
  "rock-and-roll-led-neon-sign": {"backboard":"Clear"},
  "rock-and-roll-skull-led-neon-sign": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "rock-n-roll-kiity-led-neon-sign": {"colours":["Golden Yellow","Cold White","Blue"],"backboard":"Clear"},
  "rocket-btc": {"colours":["Cold White","Blue","Lemon Yellow","Red"],"backboard":"Clear"},
  "roll-of-the-dice-led-neon-sign": {"colours":["Red","Blue"],"backboard":"UV Print"},
  "rolling-stones-logo": {"backboard":"UV Print"},
  "roos-led-neon-sign": {"backboard":"Clear"},
  "rose-bud-led-neon-sign": {"colours":["Red","Ice Blue"],"backboard":"Clear"},
  "rose-led-neon-sign": {"backboard":"Clear"},
  "rudolf": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "saint-nick": {"colours":["Cold White","Red","Ice Blue"],"backboard":"Clear"},
  "salt-lake-soccer-team-led-neon-sign": {"colours":["Red","Orange","Lemon Yellow"],"backboard":"UV Print"},
  "salud-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Ice Blue"],"backboard":"Clear"},
  "san-diego-baseball-led-neon-sign": {"colours":["Cold White"],"backboard":"Clear"},
  "san-diego-lacrosse-team-led-neon-sign": {"colours":["Cold White","Golden Yellow"],"backboard":"UV Print"},
  "san-diego-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "san-fran-led-neon-sign": {"colours":["Blue","Red"],"backboard":"Clear"},
  "san-francisco-american-football-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "san-franciso-baseball-led-neon-sign": {"colours":["Orange"],"backboard":"Clear"},
  "san-jose-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "sandwich-led-neon-sign": {"colours":["Cold White","Orange","Green","Lemon Yellow"],"backboard":"Clear"},
  "santa-hat": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "saskatchewan-lacrosse-team-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "sausage-dog-led-neon-sign": {"backboard":"Clear"},
  "save-water-drink-champagne-led-neon-sign": {"colours":["Pink","Ice Blue","Lemon Yellow","Red"],"backboard":"Clear"},
  "saxaphone-led-neon-sign": {"backboard":"Clear"},
  "saxaphones-notes-led-neon-sign": {"colours":["Cold White","Lemon Yellow"],"backboard":"Clear"},
  "scissor-open": {"colours":["Pink","Green"],"backboard":"Clear"},
  "scooter-squirrel-led-neon-sign": {"colours":["Orange","Cold White"],"backboard":"Clear"},
  "scream": {"backboard":"Clear"},
  "seagulls-led-neon-sign": {"colours":["Blue","Cold White","Golden Yellow"],"backboard":"UV Print"},
  "sean-wotherspoon-airmax-97": {"colours":["Cold White","Orange","Red","Purple"],"backboard":"Clear"},
  "seattle-american-football-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "seattle-baseball-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "seattle-soccer-team-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "selfie-here-led-neon-sign": {"backboard":"Clear"},
  "sexy-as-f-led-neon-sign": {"backboard":"Clear"},
  "shellac-led-neon-sign": {"backboard":"Clear"},
  "shenran-led-neon-sign": {"backboard":"Clear"},
  "sherrif": {"backboard":"Clear"},
  "sherriff-bulldog-led-neon-sign": {"colours":["Blue","Red","Cold White"],"backboard":"Clear"},
  "shisha-led-neon-sign": {"colours":["Orange","Pink","Cold White","Blue"],"backboard":"Clear"},
  "simple-barbershop-led-neon-sign": {"backboard":"Clear"},
  "simple-bat": {"backboard":"Clear"},
  "simple-exit": {"backboard":"Clear"},
  "simple-flamingo": {"backboard":"Clear"},
  "simple-ghost-1": {"backboard":"Clear"},
  "simple-pumpkin": {"backboard":"Clear"},
  "simple-santas-hat": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "simple-spider": {"backboard":"Clear"},
  "simple-stocking-1": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "simple-toilet": {"backboard":"Clear"},
  "simple-toilet-characters": {"colours":["Ice Blue","Pink","Cold White"],"backboard":"Clear"},
  "simple-wc-characters": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "skateboard": {"backboard":"Clear"},
  "skateboarding-puppy-led-neon-sign": {"colours":["Orange","Red","Ice Blue"],"backboard":"Clear"},
  "smiley-drip": {"backboard":"Clear"},
  "smiley-face": {"backboard":"Clear"},
  "smiling-flower-led-neon-sign": {"colours":["Cold White","Pink","Orange","Golden Yellow","Green","Ice Blue","Blue"],"backboard":"Clear"},
  "smoking-area": {"colours":["Cold White","Red"],"backboard":"Clear"},
  "smoking-area-1": {"colours":["Cold White","Green","Lemon Yellow","Orange"],"backboard":"Clear"},
  "smoking-area-2": {"colours":["Green","Lemon Yellow","Cold White","Orange"],"backboard":"Clear"},
  "smoking-area-boxed": {"colours":["Green","Cold White","Orange"],"backboard":"Clear"},
  "smoking-gorilla-led-neon-sign": {"colours":["Orange","Pink"],"backboard":"UV Print"},
  "smoking-room": {"colours":["Cold White","Red","Lemon Yellow","Orange"],"backboard":"Clear"},
  "snack-pack-led-neon-sign": {"colours":["Orange","Lemon Yellow","Red","Green","Cold White"],"backboard":"Clear"},
  "snoop-dogg": {"colours":["Lemon Yellow","Red"],"backboard":"UV Print"},
  "snorlacks-led-neon-sign": {"colours":["Ice Blue","Cold White","Purple"],"backboard":"Clear"},
  "snowflake": {"backboard":"Clear"},
  "snowflake-bauble-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"Clear"},
  "so-this-is-love-led-neon-sign": {"backboard":"Clear"},
  "sorry-we-are-closed": {"colours":["Ice Blue","Pink","Cold White"],"backboard":"Clear"},
  "sorry-we-are-closed-1": {"colours":["Red","Lemon Yellow"],"backboard":"Clear"},
  "sorry-we-are-closed-2": {"colours":["Lemon Yellow","Ice Blue"],"backboard":"Clear"},
  "spinning-records-led-neon-sign": {"colours":["Red","Ice Blue","Orange","Cold White"],"backboard":"Clear"},
  "spinning-vinyl-led-neon-sign": {"backboard":"UV Print"},
  "spongebab-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Ice Blue","Purple"],"backboard":"Clear"},
  "spurs-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "squashy-bunny-led-neon-sign": {"backboard":"Clear"},
  "squat-a-tequila-led-neon-sign": {"backboard":"Clear"},
  "squirtal-led-neon-sign-1": {"colours":["Ice Blue","Lemon Yellow","Cold White"],"backboard":"Clear"},
  "st-kilda-led-neon-sign": {"backboard":"Clear"},
  "st-louis-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "st-louis-soccer-team-led-neon-sign": {"colours":["Red","Blue"],"backboard":"UV Print"},
  "star-wars-lightsabre": {"backboard":"Clear"},
  "strong-man-led-neon-sign": {"backboard":"Clear"},
  "stronger-than-yesterday-led-neon-sign": {"backboard":"Clear"},
  "stuffed-stocking": {"colours":["Red","Orange","Cold White","Green","Pink"],"backboard":"Clear"},
  "stumpy-santa": {"colours":["Cold White","Red","Lemon Yellow","Pink"],"backboard":"Clear"},
  "sunflower-head-led-neon-sign": {"colours":["Lemon Yellow","Orange"],"backboard":"Clear"},
  "sunflower-led-neon-sign": {"colours":["Lemon Yellow","Green"],"backboard":"Clear"},
  "suns-led-neon-sign": {"backboard":"UV Print"},
  "sushi-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Red","Orange"],"backboard":"Clear"},
  "sushi-time-led-neon-sign": {"colours":["Cold White","Blue","Pink","Orange","Red","Lemon Yellow","Green"],"backboard":"Clear"},
  "sweet-16-led-neon-sign": {"backboard":"Clear"},
  "sydney-city-led-neon-sign": {"colours":["Cold White","Pink","Lemon Yellow","Blue","Ice Blue"],"backboard":"Clear"},
  "taco-is-always-the-answer-led-neon-sign": {"colours":["Orange","Cold White","Lemon Yellow","Green","Pink"],"backboard":"Clear"},
  "tacos-and-drink-led-neon-sign": {"colours":["Orange","Green","Cold White","Purple","Red"],"backboard":"Clear"},
  "tacos-led-neon-sign": {"colours":["Orange","Lemon Yellow","Green","Red"],"backboard":"Clear"},
  "talk-thirty-to-me-led-neon-sign": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "talk-thirty-to-me-led-neon-sign-1": {"backboard":"Clear"},
  "tampa-bay-american-football-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "tampa-bay-baseball-led-neon-sign": {"colours":["Blue"],"backboard":"Clear"},
  "teddy-bears-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "teenage-mutal-squirtal-led-neon-sign": {"colours":["Ice Blue","Pink","Orange","Red","Lemon Yellow"],"backboard":"Clear"},
  "tennessee-american-football-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"UV Print"},
  "tequila-and-tacos-led-neon-sign": {"colours":["Orange","Cold White","Ice Blue","Red","Green","Lemon Yellow"],"backboard":"UV Print"},
  "tequila-is-the-answer-led-neon-sign": {"colours":["Cold White","Green"],"backboard":"Clear"},
  "texas-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "thats-amore-heart-led-neon-sign": {"backboard":"Clear"},
  "thats-amore-led-neon-sign": {"backboard":"Clear"},
  "the-bar-is-open-old-school": {"colours":["Red","Blue"],"backboard":"Clear"},
  "the-barbershop-moustache-led-neon-sign": {"colours":["Cold White","Orange"],"backboard":"Clear"},
  "the-barbershop-quartet-led-neon-sign": {"colours":["Purple","Pink","White"],"backboard":"Clear"},
  "the-bees-led-neon-sign": {"colours":["Red","Cold White","Golden Yellow"],"backboard":"UV Print"},
  "the-bucks-led-neon-sign": {"backboard":"Clear"},
  "the-clarets-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "the-cottagers-led-neon-sign": {"colours":["Red","White"],"backboard":"UV Print"},
  "the-crows-led-neon-sign": {"backboard":"Clear"},
  "the-dancing-dead-led-neon-sign": {"colours":["Lemon Yellow","Ice Blue","Pink"],"backboard":"UV Print"},
  "the-dead-lifts-led-neon-sign": {"colours":["Golden Yellow","Blue","Orange"],"backboard":"Clear"},
  "the-demons-led-neon-sign": {"backboard":"Clear"},
  "the-giants-led-neon-sign": {"backboard":"Clear"},
  "the-hard-deck-led-neon-sign": {"colours":["Red","Golden Yellow","Ice Blue"],"backboard":"Clear"},
  "the-hatters-led-neon-sign": {"colours":["Blue","Cold White","Lemon Yellow"],"backboard":"UV Print"},
  "the-heat-led-neon-sign": {"colours":["Cold White","Red","Lemon Yellow"],"backboard":"Clear"},
  "the-hoops-led-neon-sign": {"colours":["Green"],"backboard":"UV Print"},
  "the-howling-dog-led-neon-sign": {"backboard":"Clear"},
  "the-lions-led-neon-sign": {"colours":["Blue","Red","Orange"],"backboard":"UV Print"},
  "the-mask-led-neon-sign": {"colours":["Red","Pink","Cold White","Lemon Yellow","Green","Ice Blue"],"backboard":"Clear"},
  "the-mustache-led-neon-sign": {"colours":["Ice Blue","Cold White"],"backboard":"Clear"},
  "the-naughty-corner-led-neon-sign": {"backboard":"Clear"},
  "the-one-whom-my-soul-loves-led-neon-sign": {"backboard":"UV Print"},
  "the-orchid-led-neon-sign": {"colours":["Purple","Ice Blue"],"backboard":"Clear"},
  "the-perfect-nails-and-brows-led-neon-sign": {"backboard":"Clear"},
  "the-reds-led-neon-sign": {"colours":["Green","Cold White","Red"],"backboard":"UV Print"},
  "the-sad-daffodil-led-neon-sign": {"colours":["Golden Yellow","Green","Pink"],"backboard":"Clear"},
  "the-shisha-led-neon-sign": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "the-swans-led-neon-sign": {"backboard":"Clear"},
  "the-wolves-led-neon-sign": {"colours":["Cold White","Lemon Yellow"],"backboard":"UV Print"},
  "theres-no-place-like-home-led-neon-sign": {"backboard":"Clear"},
  "theres-no-place-like-home-led-neon-sign-1": {"backboard":"Clear"},
  "think-led-neon-sign": {"backboard":"Clear"},
  "third-eye": {"colours":["Pink","Cold White","Green","Red","Orange","Blue","Lemon Yellow"],"backboard":"Clear"},
  "thirsty-girl-anime-led-neon-sign": {"colours":["Lemon Yellow","Cold White","Pink"],"backboard":"Clear"},
  "thirty-flirty-thriving-led-neon-sign": {"backboard":"Clear"},
  "this-is-our-happy-place-led-neon-sign": {"backboard":"Clear"},
  "three-bunnies-led-neon-sign": {"backboard":"Clear"},
  "tick-drip": {"backboard":"Clear"},
  "til-death-do-us-party-led-neon-sign": {"backboard":"Clear"},
  "til-death-led-neon-sign": {"backboard":"Clear"},
  "to-glam-to-give-a-dam-led-neon-sign": {"backboard":"Clear"},
  "to-us-led-neon-sign": {"backboard":"Clear"},
  "toffees-led-neon-sign": {"colours":["Blue"],"backboard":"UV Print"},
  "together-forever-led-neon-sign": {"backboard":"Clear"},
  "toilet-2": {"backboard":"Clear"},
  "toilet-bow-characters": {"colours":["Cold White","Ice Blue","Pink"],"backboard":"Clear"},
  "toilet-bows": {"colours":["Ice Blue","Cold White","Pink"],"backboard":"Clear"},
  "toilet-boxed": {"colours":["Lemon Yellow","Cold White"],"backboard":"Clear"},
  "toilet-characters": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "toilet-left": {"colours":["Red","Ice Blue"],"backboard":"Clear"},
  "toilet-people": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "toilet-right": {"colours":["Ice Blue","Red"],"backboard":"Clear"},
  "toronto-blue-baseball-led-neon-sign": {"colours":["Blue","Red"],"backboard":"UV Print"},
  "toronto-lacrosse-team-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "toronto-soccer-team-led-neon-sign": {"colours":["Red"],"backboard":"UV Print"},
  "train-hard-led-neon-sign": {"backboard":"Clear"},
  "treat-yourself-led-neon-sign": {"backboard":"Clear"},
  "treat-yourself-led-neon-sign-1": {"backboard":"Clear"},
  "trick-or-treat-1": {"colours":["Orange","Purple"],"backboard":"UV Print"},
  "trick-or-treat-2": {"backboard":"Clear"},
  "trucking-gorilla-led-neon-sign": {"colours":["Lemon Yellow","Green","Purple","Orange","Cold White"],"backboard":"UV Print"},
  "truly-madly-deeply-led-neon-sign": {"backboard":"Clear"},
  "trust-me-you-can-dance": {"backboard":"Clear"},
  "turn-up-the-mic-led-neon-sign": {"backboard":"Clear"},
  "turtle-led-neon-sign": {"colours":["Ice Blue","Orange","Lemon Yellow"],"backboard":"Clear"},
  "twenty-one-led-neon-sign": {"backboard":"Clear"},
  "ufc-led-neon-sign": {"backboard":"Clear"},
  "ufo-led-neon-sign": {"colours":["Ice Blue","Orange","Green"],"backboard":"Clear"},
  "ultimate-control-led-neon-sign": {"colours":["Pink","Ice Blue","Cold White","Red","Lemon Yellow","Green","Blue"],"backboard":"Clear"},
  "unicorn-led-neon-sign": {"colours":["Cold White","Pink","Purple"],"backboard":"Clear"},
  "up-up-and-away-led-neon-sign": {"colours":["Ice Blue","Lemon Yellow","Red","Blue"],"backboard":"UV Print"},
  "vancouver-lacrosse-team-led-neon-sign": {"colours":["Warm White"],"backboard":"UV Print"},
  "vancouver-soccer-team-led-neon-sign": {"colours":["Cold White","Ice Blue"],"backboard":"UV Print"},
  "vegan-food-led-neon-sign": {"colours":["Green","Cold White","Red","Orange","Purple"],"backboard":"Clear"},
  "vegas-hockey-led-neon-sign": {"colours":["Cold White"],"backboard":"UV Print"},
  "villans-led-neon-sign": {"colours":["Ice Blue","Golden Yellow"],"backboard":"UV Print"},
  "villans-led-neon-sign-1": {"colours":["Red"],"backboard":"UV Print"},
  "vinyl": {"colours":["Ice Blue","Purple"],"backboard":"Clear"},
  "vinyl-deck": {"colours":["Purple","Ice Blue","Pink"],"backboard":"Clear"},
  "viva-mexico-led-neon-sign": {"colours":["Green","Warm White","Red","Cold White"],"backboard":"Clear"},
  "viva-mexico-led-neon-sign-1": {"colours":["Red","Green","Cold White"],"backboard":"UV Print"},
  "volleyball": {"backboard":"Clear"},
  "vr-games-led-neon-sign": {"colours":["Pink","Red","Ice Blue","Blue"],"backboard":"Clear"},
  "w-pink-m-blue": {"colours":["Pink","Ice Blue"],"backboard":"Clear"},
  "walking-dead-led-neon-sign": {"colours":["Cold White","Red","Warm White","Green"],"backboard":"Clear"},
  "wash-rinse-repeat-led-neon-sign": {"backboard":"Clear"},
  "washington-american-football-led-neon-sign": {"colours":["Golden Yellow"],"backboard":"UV Print"},
  "washington-baseball-led-neon-sign": {"colours":["Red"],"backboard":"Clear"},
  "wc": {"colours":["Ice Blue","Pink"],"backboard":"Clear"},
  "wc-eagles-1": {"colours":["Yellow","Blue"],"backboard":"Clear"},
  "we-are-open": {"colours":["Purple","Pink","Lemon Yellow"],"backboard":"Clear"},
  "wedding-led-neon-sign": {"backboard":"Clear"},
  "were-not-here-to-take-part": {"colours":["Green","Cold White","Orange"],"backboard":"Clear"},
  "were-open": {"colours":["Ice Blue","Lemon Yellow"],"backboard":"Clear"},
  "were-open-24-7": {"colours":["Green","Lemon Yellow","Blue"],"backboard":"Clear"},
  "were-open-arrow": {"colours":["Midnight Blue","Pink"],"backboard":"Clear"},
  "werk-led-neon-sign": {"backboard":"Clear"},
  "what-happens-in-the-salon-stays-in-the-salon-led-neon-sign": {"colours":["Cold White","Pink"],"backboard":"Clear"},
  "what-the-flower-led-neon-sign": {"backboard":"Clear"},
  "where-there-is-love-there-is-life-led-neon-sign": {"backboard":"Clear"},
  "wild-wild-dog-led-neon-sign": {"colours":["Cold White","Red","Blue"],"backboard":"Clear"},
  "wine-and-dine-led-neon-sign": {"backboard":"Clear"},
  "work-b-ch-led-neon-sign": {"backboard":"Clear"},
  "work-hard-led-neon-sign": {"colours":["Pink","Green"],"backboard":"UV Print"},
  "write-your-name-led-neon-sign": {"backboard":"Clear"},
  "x-marks-the-spot-led-neon-sign": {"colours":["Cold White","Lemon Yellow"],"backboard":"Clear"},
  "xbox-led-neon-sign": {"colours":["Green"],"backboard":"Clear"},
  "xmas-bells": {"colours":["Lemon Yellow","Pink"],"backboard":"Clear"},
  "xmas-candy-cane": {"colours":["Cold White","Red","Green"],"backboard":"Clear"},
  "xmas-holly": {"colours":["Green","Red"],"backboard":"Clear"},
  "xmas-jumper": {"colours":["Red","Cold White"],"backboard":"Clear"},
  "xmas-lights": {"colours":["Cold White","Green","Ice Blue","Red","Lemon Yellow"],"backboard":"Clear"},
  "xmas-lights-2": {"colours":["Cold White","Ice Blue","Lemon Yellow","Red","Green"],"backboard":"Clear"},
  "xmas-snow-globe": {"colours":["Cold White","Green","Lemon Yellow","Orange"],"backboard":"Clear"},
  "xmas-tree-snow-globe": {"colours":["Ice Blue","Red","Green","Cold White"],"backboard":"Clear"},
  "yay-its-nail-day-led-neon-sign-1": {"colours":["Pink","Cold White","Red","Orange","Ice Blue"],"backboard":"Clear"},
  "yoga-led-neon-sign": {"backboard":"Clear"},
  "yoshu-led-neon-sign": {"colours":["Green","Cold White","Orange","Red"],"backboard":"Clear"},
  "you-heart-me-led-neon-sign": {"backboard":"Clear"},
  "you-make-my-world-light-up-led-neon-sign": {"backboard":"Clear"},
  "your-nails-are-like-really-pretty-led-neon-sign": {"backboard":"Clear"},
  "youre-like-really-pretty-led-neon-sign": {"backboard":"Clear"},
  "zelda-led-neon-sign": {"colours":["Green","Ice Blue"],"backboard":"Clear"},
  "zig-zag-christmas-tree": {"colours":["Green","Cold White"],"backboard":"Clear"}
};
  root.TNF_CAT_MFG_VERSION = '1.2.0';
  if (typeof module !== 'undefined' && module.exports) module.exports = TNF_CAT_MFG;
  else root.TNF_CAT_MFG = TNF_CAT_MFG;
})(typeof window !== 'undefined' ? window : this);
